<div
	[attr.data-test-id]="name()"
	[id]="name()"
	class="list-checkmarks flex list-grid flex-col"
>
	@if (title()) {
		<div
			[attr.data-test-id]="name() + '-title'"
			[heading]="headingType()"
			class="h5 font-bold"
			vc-heading
		>
			{{ title() }}
		</div>
	}
	<ul
		[ngClass]="{ 'sm:grid-cols-2': useCol2() }"
		class="grid grid-cols-1 gap-4"
		data-test-class="list-items"
	>
		@for (
			item of listItems() | slice: 0 : (useCol2() ? 10 : 5);
			track $index
		) {
			<li>{{ item }}</li>
		}
	</ul>
	@if (listItems().length > (useCol2() ? 10 : 5)) {
		<button
			[id]="name() + '-trigger-sheet'"
			class="mt-4 w-fit text-link cursor-pointer"
			vp-sheet-trigger
		>
			{{ 'global.show-more' | translate }}
		</button>
	}
</div>

<vp-sheet
	[attr.data-test-id]="name() + '-sheet'"
	[isLoading]="false"
	[triggerId]="name() + '-trigger-sheet'"
	sheetWidth="third"
>
	<vp-sheet-header>
		<span class="h2 block">
			{{ sheetTitle() }}
		</span>
	</vp-sheet-header>
	<vp-sheet-content id="sheet-content" tabindex="0">
		<div class="list-checkmarks">
			<ul>
				@for (item of listItems() || []; track $index) {
					<li>{{ item }}</li>
				}
			</ul>
		</div>
	</vp-sheet-content>
</vp-sheet>
